import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface Props {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  ticketTitle: string;
  onConfirm: (note: string) => Promise<void>;
}

export function ResolveDialog({ open, onOpenChange, ticketTitle, onConfirm }: Props) {
  const [note, setNote] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = async () => {
    setSubmitting(true);
    try {
      await onConfirm(note);
      setNote('');
      onOpenChange(false);
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = (next: boolean) => {
    if (!next) setNote('');
    onOpenChange(next);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-brand text-base">Resolver chamado</DialogTitle>
          <DialogDescription className="line-clamp-2">{ticketTitle}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 py-2">
          <Label htmlFor="resolve-note">Nota de resolução (opcional)</Label>
          <Textarea
            id="resolve-note"
            placeholder="O que foi feito para resolver?"
            rows={4}
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </div>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => handleClose(false)}
            disabled={submitting}
          >
            Cancelar
          </Button>
          <Button onClick={handleConfirm} disabled={submitting} variant="income">
            {submitting ? (
              <>
                <Loader2 size={14} className="mr-2 animate-spin" />
                Resolvendo…
              </>
            ) : (
              'Marcar como resolvido'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
